import './dayjs.extend';
import { ApolloProvider } from '@apollo/client/react';
import { Toaster } from 'react-hot-toast';
import apolloClient from './apolloClient';
import UserSessionProvider from './contexts/UserSession';
import AppRoutes from './routes';
import SubscriptionManager from './subscriptions';

const App = () => (
    <ApolloProvider client={apolloClient}>
        <UserSessionProvider>
            <SubscriptionManager />
            <AppRoutes />
            <Toaster />
        </UserSessionProvider>
    </ApolloProvider>
);

export default App;
